import React from "react";
import Features from "../../api/Features";
import SectionTitle from "../SectionTitle/SectionTitle";
import FeatureCard from "./FeatureCard";

const SummitFeaturesSection = (props) => {
  return (
    <section className={"section-padding " + props.hclass}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="Summit Features"
              titleStyle={{ color: "#252686" }}
              subtitle=""
              paragarap="Experience a revolutionary approach to business events with our innovative features designed to maximize value and impact."
              paragraphStyle={{ color: "#525252" }}
            />
          </div>
        </div>
        <div className="services-wrap">
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            {Features.map((item, findx) => (
              <div
                className="col col-xl-4 col-lg-6 col-md-6 col-12"
                key={findx}
                style={{ display: "flex" }}
              >
                <FeatureCard
                  key={findx}
                  title={item.title}
                  fImg={item.fImg}
                  description={item.description}
                  buttonText={item.buttonText}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SummitFeaturesSection;
